<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          固定貨物検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center" ref="_calcHeight-Row2">
                  <v-col :cols="4">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-text-box
                          label="固定貨物タイトル"
                          v-model="conditions.teikeiKihonNm"
                          ref="teikeiKihonNm"
                          :length="50"
                          :valueType="Ctrls.InputTypes.Free"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="4">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="担当営業所コード/名称"
                          v-model="conditions.tantoEigyoshoCd"
                          ref="tantoEigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="mstEigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="4">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="荷主コード/名称"
                          v-model="conditions.ninushiCd"
                          ref="ninushiCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="取引先マスタ検索"
                          :headerList="mstTorihikisakiHeader"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :itemList="filteredTokuisakiList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters align-content="center" ref="_calcHeight-Row3">
                  <v-col :cols="9">
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center" ref="_calcHeight-Row4">
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                singleSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
         <dd-footer-button
           @click="onCloseClick">
           閉じる
         </dd-footer-button>
         <v-spacer></v-spacer>
         <dd-footer-button
           :disabled="isSelectButtonDisabled"
           @click="onSelectButtonClick">
           選択
         </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')

export default {
  name: 'ThKoteiKamotsuNoSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdTextBox,
    DdFooterButton,
    DdCodeTextBox,
    DdDataTable,
    DdRowCountBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      teikeiKihonNm: '',
      tantoEigyoshoCd: '',
      ninushiCd: ''
    },
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
    /*
     *
     */
  }),
  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '固定貨物検索')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeader = header.mstTorihikisakiHeaders
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        return elem
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKoteiKamotsuNoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: '固定貨物タイトル', value: 'teikeiKihonNm' },
              { text: '担当営業所', value: 'tantoEigyoshoNm' },
              { text: '荷主', value: 'ninushiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '卸先', value: 'oroshisakiNm' },
              { text: '着地', value: 'chakuchiNm' }]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          this.conditions.teikeiKihonNm = c.koteiKamotsuTeikeiKihonNm !== undefined && c.koteiKamotsuTeikeiKihonNm !== '' && c.koteiKamotsuTeikeiKihonNm !== null ? c.koteiKamotsuTeikeiKihonNm : ''
          this.conditions.tantoEigyoshoCd = c.koteiKamotsuTantoEigyoshoCd !== undefined && c.koteiKamotsuTantoEigyoshoCd !== '' && c.koteiKamotsuTantoEigyoshoCd !== null ? c.koteiKamotsuTantoEigyoshoCd : ''
          this.conditions.ninushiCd = c.koteiKamotsuNinushiCd !== undefined && c.koteiKamotsuNinushiCd !== '' && c.koteiKamotsuNinushiCd !== null ? c.koteiKamotsuNinushiCd : ''
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKoteiKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKoteiKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThrcod00102/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('THRCOD0010', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            koteiKamotsuTeikeiKihonNm: self.conditions.teikeiKihonNm ? self.conditions.teikeiKihonNm : '',
            koteiKamotsuTantoEigyoshoCd: self.conditions.tantoEigyoshoCd ? self.conditions.tantoEigyoshoCd : '',
            koteiKamotsuNinushiCd: self.conditions.ninushiCd ? self.conditions.ninushiCd : ''
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = []
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      // this.clear(false)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        teikeiKihonNm: '',
        tantoEigyoshoCd: '',
        ninushiCd: ''
      }
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 520 !important;
}
</style>
